module.exports = __webpack_public_path__ + "static/media/newLMSLogo.c5adc20e.png";